<template>
  <el-select
    ref="selectRef"
    v-model="innerValue"
    filterable
    remote
    reserve-keyword
    clearable
    :popper-class="dropdownClass"
    :remote-method="handleSearch"
    placeholder="请输入产品编码"
    @change="handleChange"
    @visible-change="handleVisibleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.productCode"
      :label="item.productCode"
      :value="item.productCode"
    >
      <span>{{ item.productCode }}</span>
      <span class="option-name">{{ item.productName }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'WaitAddProductSelect',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    dropdownClass () {
      return `wait-add-product-select-dropdown-${this._uid}`
    }
  },
  data () {
    return {
      innerValue: '',
      loading: false,
      options: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      keyword: '',
      dropdownScrollWrap: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.innerValue = val
      }
    }
  },
  methods: {
    handleVisibleChange (visible) {
      if (visible && !this.options.length) {
        this.fetchOptions(true)
      }
      if (visible) {
        this.bindScroll()
      } else {
        this.unbindScroll()
      }
    },
    handleSearch (query) {
      this.keyword = query
      this.fetchOptions(true)
    },
    loadMore () {
      if (this.loading || this.options.length >= this.total) {
        return
      }
      this.pageNum += 1
      this.fetchOptions()
    },
    fetchOptions (reset = false) {
      if (reset) {
        this.pageNum = 1
        this.options = []
      }
      this.loading = true
      const data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          productCode: this.keyword
        }
      }
      this.$q.product.waitAddRetailPriceProductList({ data }).then((res) => {
        if (res && Number(res.code) === 200 && res.data) {
          const records = res.data.records || []
          this.total = res.data.total || 0
          this.options = reset ? records : [...this.options, ...records]
        } else {
          this.total = 0
          this.options = reset ? [] : this.options
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleChange (value) {
      this.$emit('input', value)
      const current = this.options.find(item => item.productCode === value) || null
      this.$emit('select', current)
    },
    handleDropdownScroll () {
      if (!this.dropdownScrollWrap) {
        return
      }
      const reachBottom = this.dropdownScrollWrap.scrollHeight - this.dropdownScrollWrap.scrollTop <= this.dropdownScrollWrap.clientHeight + 10
      if (reachBottom) {
        this.loadMore()
      }
    },
    bindScroll () {
      this.$nextTick(() => {
        const dropdownWrap = document.querySelector(`.${this.dropdownClass} .el-select-dropdown__wrap`)
        if (!dropdownWrap || dropdownWrap === this.dropdownScrollWrap) {
          return
        }
        this.unbindScroll()
        this.dropdownScrollWrap = dropdownWrap
        dropdownWrap.addEventListener('scroll', this.handleDropdownScroll)
      })
    },
    unbindScroll () {
      if (!this.dropdownScrollWrap) {
        return
      }
      this.dropdownScrollWrap.removeEventListener('scroll', this.handleDropdownScroll)
      this.dropdownScrollWrap = null
    }
  },
  beforeDestroy () {
    this.unbindScroll()
  }
}
</script>

<style lang="stylus" scoped>
.option-name
  float right
  color #909399
</style>
